import React, { useState } from "react";
import emailjs from "emailjs-com"; // Import EmailJS library

const publicAPI = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
emailjs.init(publicAPI);

const NewsletterForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const validateForm = () => {
    const { firstName, lastName, email } = formData;
    if (!firstName || !lastName || !email) {
      setError("All fields are required!");
      return false;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError("Please enter a valid email address.");
      return false;
    }
    setError(null);
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const templateParams = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
    };

    emailjs.send(serviceID, "newsletter_form_template", templateParams).then(
      (response) => {
        console.log("Email sent successfully:", response);
        setSuccess(true);
        setError(null);
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
        });

        // Hide success message after 10 seconds
        setTimeout(() => {
          setSuccess(false);
        }, 10000);
      },
      (error) => {
        console.error("Failed to send email:", error);
        setError("Something went wrong. Please try again.");

        // Hide error message after 10 seconds
        setTimeout(() => {
          setError(null);
        }, 10000);
      }
    );
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-md mx-auto md:ml-4">
      <h2 className="text-left text-3xl font-raleway text-black mb-4">
        Stay Informed
      </h2>
      <p className="text-sm font-inter text-black mb-4">
        Subscribe to our newsletter to receive updates on the latest news and
        events.
      </p>

      {error && (
        <div className="text-red-500 text-sm font-inter mb-4">
          <p>{error}</p>
        </div>
      )}

      {success && (
        <div className="text-green-500 text-sm font-inter mb-4">
          <p>Thank you for subscribing! We'll be in touch soon.</p>
        </div>
      )}

      <form className="space-y-4" onSubmit={handleSubmit}>
        <div>
          <label
            htmlFor="firstName"
            className="block text-sm font-inter text-black mb-1"
          >
            First Name*
          </label>
          <input
            id="firstName"
            type="text"
            value={formData.firstName}
            onChange={handleChange}
            className="w-full h-12 border border-gray-500 rounded px-3"
          />
        </div>
        <div>
          <label
            htmlFor="lastName"
            className="block text-sm font-inter text-black mb-1"
          >
            Last Name*
          </label>
          <input
            id="lastName"
            type="text"
            value={formData.lastName}
            onChange={handleChange}
            className="w-full h-12 border border-gray-500 rounded px-3"
          />
        </div>
        <div>
          <label
            htmlFor="email"
            className="block text-sm font-inter text-black mb-1"
          >
            Email*
          </label>
          <input
            id="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full h-12 border border-gray-500 rounded px-3"
          />
        </div>
        <button
          type="submit"
          className="w-full h-12 bg-gray-700 text-white text-lg font-raleway rounded-lg 
             hover:bg-gray-900 hover:shadow-lg transition-all duration-200"
        >
          Sign Me Up
        </button>
      </form>
    </div>
  );
};

export default NewsletterForm;
